T.Counter = function(node, start = 0, end, duration = 1000) {
	let startTs = null;
	const step = (ts) => {
		if (!startTs) {
			startTs = startTs || ts;
		}
		const easeOutQuad = t => t * ( 2 - t );
		const progress = easeOutQuad( Math.min((ts - startTs) / duration, 1) );
		node.innerText = Math.floor(progress * (end - start) + start);
		if (progress < 1) {
			window.requestAnimationFrame(step);
		}
	};
	window.requestAnimationFrame(step);
};